// extracted by mini-css-extract-plugin
export default {"content":"modalStyles_content__8BjJa","iconBlock":"modalStyles_iconBlock__llVXG","actionButtonsContainer":"modalStyles_actionButtonsContainer__St5oW"};